var map = {
	"./ArmoredKingdom1.png": 81919,
	"./ArmoredKingdom2.png": 94217,
	"./ArmoredKingdom3.png": 47445,
	"./ArmoredKingdom4.png": 7608,
	"./Vector-down.png": 96048,
	"./Vector-up.png": 97951,
	"./land1.png": 17694,
	"./land2.png": 2017,
	"./land3.png": 3736,
	"./land4.png": 66985,
	"./land5.png": 7581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31943;